import Chart from 'react-apexcharts';

interface IChart {
  pieChartNumbers: number[];
  pieChartLabels: string[];
  pieChartColor: string[];
}

function PieChart({ pieChartNumbers, pieChartLabels, pieChartColor }: IChart) {
  const options = {
    chart: {
      type: 'pie' as const,
      dropShadow: { enabled: false },
    },
    legend: {
      show: true,
      position: 'bottom' as const,
      fontSize: '13px',
      labels: { colors: '#525252' },
    },
    labels: pieChartLabels,
    colors: pieChartColor,
    dataLabels: {
      formatter: (val: number) => `${val.toFixed(1)}%`,
      dropShadow: { enabled: false },
      style: {
        fontSize: '12px',
        fontWeight: 500,
      },
    },
    stroke: {
      width: 1,
      colors: ['#fff'],
    },
    tooltip: {
      y: {
        formatter: (val: number) => `${val}`,
      },
    },
  };

  const series = pieChartNumbers;

  return (
    <div className="w-full max-w-2xl">
      <Chart options={options} series={series} type="pie" width="100%" height="480" />
    </div>
  );
}

export default PieChart;
